import React, { useMemo } from 'react'

import { TableSortType } from 'src/components/molecules'
import { ExternalAssignUserSortItemType } from 'src/components/molecules/projects/ExternalAssignUserTableHead'
import { ExternalAssignUserTableRow } from 'src/components/molecules/projects/ExternalAssignUserTableRow'

import { useGetExternalUsers } from 'src/hooks'
import { ProjectAssignUserEntity } from 'src/types'

type Props = {
  externalAssignedUsers: ProjectAssignUserEntity[]
  sortItem: ExternalAssignUserSortItemType
  sortType: TableSortType
  className?: string
}

export function ExternalAssignUserTableBody({
  externalAssignedUsers,
  sortItem,
  sortType,
  className,
}: Props) {
  const { externalUsers } = useGetExternalUsers()

  const sortedExternalUsers = useMemo(() => {
    return [...externalAssignedUsers].sort((a, b) => {
      const order = sortType === 'desc' ? 1 : -1

      if (sortItem === 'name') {
        return (a.name ?? '-') < (b.name ?? '-') ? order : -order
      }
      if (sortItem === 'email') {
        return (a.email ?? '-') < (b.email ?? '-') ? order : -order
      }
      if (sortItem === 'keywords') {
        const aKeywords = externalUsers.find(user => user.id === a.id)?.keywords
        const aTargetKeywords = aKeywords && aKeywords.length > 0 ? aKeywords[0] : '-'
        const bKeywords = externalUsers.find(user => user.id === b.id)?.keywords
        const bTargetKeywords = bKeywords && bKeywords.length > 0 ? bKeywords[0] : '-'
        return aTargetKeywords < bTargetKeywords ? order : -order
      }

      if (sortItem === 'assignedAt') {
        return a.assignedAt < b.assignedAt ? order : -order
      }
      if (sortItem === 'compassRole') {
        return a.compassRole.priority < b.compassRole.priority ? order : -order
      }

      return 0
    })
  }, [externalAssignedUsers, externalUsers, sortItem, sortType])

  return (
    <div className={className}>
      <ul>
        {sortedExternalUsers.map(externalUser => (
          <li
            className="tw-centering tw-border-b tw-border-b-border-secondary last:tw-border-b-0"
            key={externalUser.id}
          >
            <a
              href={`/external-users/${externalUser.id}`}
              className="hover:tw-bg-surface-secondary tw-bg-surface-primary tw-w-full"
              target="_blank"
              rel="noreferrer"
            >
              <ExternalAssignUserTableRow externalUser={externalUser} className="tw-w-full" />
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}
